import { useCifraClient } from "../../cifra-client";

const { cifraClient } = useCifraClient();

export default {
  guardar(datos, options) {
    return cifraClient.post('/transporte/eventuales', datos, options);
  },
};
